import { t } from '@/locale/index.js'

/** 用户新增/编辑弹窗：校验文案 */
export function applyUserFormRules(rules) {
  if (rules?.username?.[0]) rules.username[0].message = t('userForm.needUsername')
  if (rules?.english_name?.[0]) rules.english_name[0].message = t('userForm.needEnglishName')
  if (rules?.id_card?.[0]) rules.id_card[0].message = t('userForm.needIdCard')
  if (rules?.address?.[0]) rules.address[0].message = t('userForm.needAddress')
}

export { t }
